import React, { useContext, useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  AiFillCheckCircle,
  AiFillCloseCircle,
  AiFillWindows,
} from "react-icons/ai";
import DocumentBuilder from "./DocumentBuilder";
import { BlobProvider, PDFViewer, StyleSheet } from "@react-pdf/renderer";
import { WsContext } from "../../App";
import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import Loading from "../../components/Loading";
import { setReminder } from "../../features/UserActions";
import { useDispatch } from "react-redux";
import { ConvertDateFromSQL } from "../../core/ThaiDate";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";
import { StudyReportService } from "../../model/study-report";
import { Oval } from "react-loading-icons";

export default function PopupReportPdf(props) {
  const [winState, setWinState] = props.winState;
  const [loading, setLoading] = props.loading;
  const [subLoading, setSubLoading] = useState(false);

  const data = props.data;
  const userDetail = props.userInfo;

  const dispatch = useDispatch();
  const [docu, setDocu] = useState();

  // use web socket request
  const [ws, setWs] = useContext(WsContext);

  // useEffect(() => {
  //   setDocu(
  //     <DocumentBuilder
  //       data={data}
  //       setLoading={setLoading}
  //       userDetail={userDetail}
  //     />,
  //   );
  // }, [data]);

  const handleConfirm = () => {
    // เรียก action ของ winState ถ้ามี เพื่อปิด popup และทำงานต่อ
    if (winState.action) {
      winState.action();
    }
  };

  const handleClose = () => {
    // เรียก action ของ winState ถ้ามี เพื่อปิด popup และทำงานต่อ
    setWinState((pv) => ({ ...pv, show: false }));
  };

  const uploadPdfBlob = async (bl, url, nextFnc) => {
    setSubLoading(true);

    // let buildForDownload = false;

    // if (buildforDownload) {
    //   var formData = new FormData();
    //   formData.append("userInfo", JSON.stringify(userDetail));
    //   formData.append("studyInfo", JSON.stringify(data?.studyInfo));
    //   formData.append("blob", bl);
    // }

    let res = await StudyReportService.ApproveAReport({
      userInfo: userDetail,
      studyInfo: data?.studyInfo,
    });

    setSubLoading(false);
    if (res?.result == true) {
      handleConfirm();
    }
  };

  const sendPacsToLoadPdf = (informPacs) => {
    // * Send Websocket command
    // * 32201 = open folder or viewer app

    if (informPacs) {
      let cmd = "31203";
      let info = {
        userId: userDetail.userid,
        srcStaff: userDetail.staffid,
        targetStaff: userDetail.staffid,
        destStaff: userDetail.staffid,
        reqCommand: cmd,
        srcSessionType: 3,
        targetSessionType: 2,
        destSessionType: 2,
        studyId: data?.studyInfo?.pacs_study_id, //  study_instance_uid
      };
      ws?.sendJsonMessage(info);
    }

    dispatch(
      setReminder({
        show: true,
        message: "แจ้ง PACS เพื่อรับข้อมูลแล้ว",
        type: "success",
      }),
    );
    // setWinState({ show: false });
    if (winState.action) {
      winState.action();
    }
  };

  return (
    <MyModal
      style={{ zIndex: "10000", background: "black" }}
      show={winState && winState.show}
      size="xl"
      centered

      // fullscreen
    >
      <ModalHeaderBlack>
        <div
          style={{
            color: "white",
            textAlign: "center",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          อนุมัติผลการวินิจฉัย
        </div>
      </ModalHeaderBlack>

      {/* BODY */}
      <ModalBodyBlack style={{ padding: "0px" }}>
        {/* <PDFViewer style={styles.container} children={docu}></PDFViewer> */}

        <div
          style={{
            flex: "1",
            display: "flex",
            marginInline: "auto",
            background: "none",
            borderRadius: "5px",
            justifyContent: "center",
            flexDirection: "row",
            paddingBlock: "50px",
          }}
        >
          {/* <BlobProvider document={docu}>
            {(a) => {
              //if (a.url != null) {
              return (
                <Button
                  style={{ margin: "10px" }}
                  onClick={() => {
                    if (!subLoading) {
                      uploadPdfBlob(a.blob, a.url, (result) => {
                        if (result === "ok") {
                          sendPacsToLoadPdf();
                        }
                      });
                    }
                  }}
                >
                  {subLoading ? (
                    <Oval
                      stroke="yellow"
                      height="50px"
                      width="50px"
                      style={{ marginInline: "10px" }}
                    />
                  ) : (
                    <AiFillCheckCircle
                      style={{
                        color: "yellow",
                        width: "50px",
                        height: "50px",
                      }}
                    />
                  )}
                  APPROVES และ ส่ง PACS
                </Button>
              );
              //}
            }}
          </BlobProvider> */}

          <Button
            style={{ margin: "10px" }}
            onClick={() => {
              if (!subLoading) {
                // uploadPdfBlob( a.blob, a.url, (result) => {
                uploadPdfBlob(null, null, (result) => {
                  if (result === "ok") {
                    sendPacsToLoadPdf();
                  }
                });
              }
            }}
          >
            {subLoading ? (
              <Oval
                stroke="yellow"
                height="50px"
                width="50px"
                style={{ marginInline: "10px" }}
              />
            ) : (
              <AiFillCheckCircle
                style={{
                  color: "yellow",
                  width: "50px",
                  height: "50px",
                  marginInlineEnd: "20px",
                }}
              />
            )}
            อนุมัติผล
          </Button>

          {/*  */}
          <Button
            style={{ margin: "10px", display: "none" }}
            onClick={() => {
              //handleClose(2);
            }}
          >
            <AiFillWindows style={{ color: "yellow" }} />
            Viewer
          </Button>

          {/*  */}

          <Button
            variant="danger"
            style={{ margin: "10px 10px 10px 10px" }}
            onClick={() => {
              handleClose();
            }}
          >
            <AiFillCloseCircle
              style={{
                color: "yellow",
                width: "50px",
                height: "50px",
                marginHorizontal: "20px",
              }}
            />
            ยกเลิก
          </Button>
        </div>
      </ModalBodyBlack>

      {/* Footer */}
      <ModalFooterBlack></ModalFooterBlack>
    </MyModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "99%",
    height: "99%",
    marginHorizontal: 0,
  },
});
